// Status color mapping - using Bootstrap CSS variables from DispatchBoard.scss
export const statusColors = {
    'Unfilled': '#777',
    'Scheduled': 'var(--warning)', // Bootstrap warning yellow
    'No Response': 'var(--danger)', // Bootstrap danger red
    'Confirmed': 'var(--success)', // Bootstrap success green
    'Cancel Pending': 'var(--danger)', // Bootstrap danger red
    'Cancel Confirmed': 'var(--success)', // Bootstrap success green
};
